import { render, staticRenderFns } from "./BookingCancellation.vue?vue&type=template&id=0afb1948&scoped=true"
import script from "./BookingCancellation.vue?vue&type=script&lang=js"
export * from "./BookingCancellation.vue?vue&type=script&lang=js"
import style0 from "./BookingCancellation.vue?vue&type=style&index=0&id=0afb1948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afb1948",
  null
  
)

export default component.exports